import styled from "styled-components";
import fontWeight from "@src/design-tokens/font-weight";
import margin from "@src/design-tokens/margin";

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: ${fontWeight.bold};
  margin-bottom: ${margin.m4};
`;
